import { useEffect } from 'react';
import ReactTooltip from 'react-tooltip';

export const useTooltip = (deps?: Array<any>) => {
  useEffect(() => {
    ReactTooltip.rebuild();
  }, deps);
};
